import "./ElectronicsTechnician.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import DetallesDelCurso from "./sections/DetallesDelCurso";
import CourseCatalog from "./sections/CourseCatalog";
import Footer from "@/reusable_sections/Footer";
export default function ElectronicsTechnicianPage() {
  return <div>
      <Header />
      <Hero />
      <DetallesDelCurso />
      <CourseCatalog />
      <Footer />
    </div>;
}